/**
 * Local-time yyyy-MM-dd, matching what a type="date" input reads and writes. Deliberately not
 * toISOString(), which is UTC and so reports yesterday's date during the Dutch evening.
 */
export const toISODate = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return [String(date.getFullYear()), month, day].join('-');
};

export const todayISO = (): string => toISODate(new Date());

export const tomorrowISO = (): string => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return toISODate(tomorrow);
};

export const oneYearAheadISO = (): string => {
  const nextYear = new Date();
  nextYear.setFullYear(nextYear.getFullYear() + 1);
  return toISODate(nextYear);
};
